import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { CCard, CCardBody, CCol, CRow, CProgress, CLabel, CTextarea, CButton, CImage } from 'compat/coreui'
import axios from 'axios';
import Rating from 'react-rating';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';


export default function PhotosSections({ seller }) {
    const [review, setReview] = useState('');
    const [rating, setRating] = useState(0);
    const [value, setValue] = useState(0);
    const [voteCount, setVoteCount] = useState(0);
    const [show, setShow] = useState(false);
    const token = localStorage.getItem('token');
    const user = useSelector(state => state.user);
    console.log("promoImagepromoImagepromoImage-->> ", seller);
    const reviewHandler = (e) => {

        e.preventDefault();
        axios({
            url: `${process.env.REACT_APP_APP_API_URL}/api/review`,
            headers: {
                Authorization: `Bearer ${token}`
            },
            method: `POST`,
            data: {
                reviewed: seller._id,
                reviewer: user._id,
                msg: review,
                type: 2,
                rating: value,
            }
        }).then(response => { 
            // console.log('review api response', response);
            if (response.data.status) {
                toast.success('Reviewed successfully');
                setReview("");
                setValue(0);
            } else {
                toast.error(response.message)
            }
        }).catch(console.log)
    }


    return (
        <div>
            <CCard className="business-dashboard-new">
                <CRow>
                    {(seller.promoImage) && seller.promoImage.map((item, index) => {
                        return (<CCol sm="3" className="m-auto" key={index}>
                            <div style={{ marginBottom: "5%" }}>
                                <CImage style={{ maxWidth: "100%" }} src={"https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + item} />
                            </div>
                        </CCol>)
                    })}
                </CRow>
            </CCard>
        </div>
    )
}